import { useQuery } from "@tanstack/react-query";
import { GetValueOptionsRequest } from "./api";

type Props = {
    namespace: string;
    category: string;
    parentCategory?: string;
    parentValue?: string;
    onSuccess?: (data: any) => void;
    onError?: (error: any) => void;
    enabled?: boolean;
}

const useGetValueOptions = ({namespace, category, parentCategory, parentValue, enabled = true, ...props}: Props) => {
    const cached_list = ['value_options', `${namespace}`, `${category}`, `${parentCategory}`, `${parentValue}`].filter((str) => str !== '')
    const {data, isLoading, isError} = useQuery<any>(cached_list, () => GetValueOptionsRequest({namespace, category, parentCategory, parentValue}), {
        onSuccess: props?.onSuccess,
        onError: props?.onError,
        enabled: enabled,
    });

    return {data, isLoading, isError};
};

export { useGetValueOptions };